import React from "react";
import cn from 'classnames';
import styles from './PopUp.module.scss'
import LineGraph from "components/echarts/LineGraph";

function PopUp(props) {
    const closeP = () => {
        props.openState(false)
    }

    const energyBalanceData = props?.data;
    return (
        <>
            <div className={cn(styles.addPopup)}>
                <div className={cn(styles.addInnerPopup)}>
                    <div>
                        <h1 className={cn(styles.title)}>Power Balance</h1>
                        <div>
                            <span className={cn(styles.close)} onClick={closeP}>x</span>
                        </div>
                    </div>
                    <div style={{ 'width': '60%', 'float': 'left' }}>
                        <div className={cn(styles.block_item)}>
                            <h3 className={cn(styles.block_item2)}>{'View as:'}</h3>
                        </div>
                        <div className={cn(styles.block_item3)}>
                            <input className={cn(styles.input_box)} type="radio" id="radio" name="view" value="viewButton1" defaultChecked />
                            <label for="hour">6h</label><br></br>
                        </div>
                        <div className={cn(styles.block_item4)}>
                            <input className={cn(styles.input_box)} type="radio" id="radio" name="view" value="viewButton2" />
                            <label for="Day">2 Days</label><br></br>
                        </div>
                        <div className={cn(styles.block_item5)}>
                            <input className={cn(styles.input_box)} type="radio" id="radio" name="view" value="viewButton3" />
                            <label for="week">1 Week</label><br></br>
                        </div>
                        <div className={cn(styles.block_item6)}>
                            <input className={cn(styles.input_box)} type="radio" id="radio" name="view" value="viewButton4" />
                            <label for="ytd">YTD</label><br></br>
                        </div>
                    </div>
                    <div style={{ 'width': '38%', 'float': 'left' }}>
                        <div className={cn(styles.block_item9)}>
                            <span className={cn(styles.dot_green)}></span>
                            <span>{'Charging'}</span>
                        </div>
                        <div className={cn(styles.block_item8)}>
                            <span className={cn(styles.dot_blue)}></span>
                            <span> {'Discharging'}</span>
                        </div>
                    </div>

                    <div className={cn(styles.power_chart)}>
                        <LineGraph data={energyBalanceData} adjustTop={'popUp'} />
                    </div>
                </div>
            </div>
        </>
    )
}
export default PopUp